import { updateComputerHand } from '../../stores/cards'
import { targetCard, handOver } from '../../stores/cardPLay'

function computerHandClick(card, index) {
  if (card.displayClass === 'transparent') return

  if (handOver()) return

  card.zoom = true

  updateComputerHand(index, card)
  targetCard(card)

  return
}

export {computerHandClick}

